import { render, staticRenderFns } from "./CrewAspBulk.vue?vue&type=template&id=6045851a"
import script from "./CrewAspBulk.vue?vue&type=script&lang=js"
export * from "./CrewAspBulk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports